module.exports = __webpack_public_path__ + "static/icon-server.a01d2921.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-server.png
// module id = 987
// module chunks = 2